import React from 'react';
import { IssueItem } from '../../models/issueItem';

interface IssueDetailHeaderProps {
  issue: IssueItem;
}

const MAX_TITLE_LEN = 80;

const IssueDetailHeader: React.FC<IssueDetailHeaderProps> = ({ issue }) => {
  const truncatedTitle = issue.title.length > MAX_TITLE_LEN 
    ? `${issue.title.substring(0, MAX_TITLE_LEN)}...` 
    : issue.title;

  return (
    <div className="flex items-center justify-between w-full p-4 text-text-color border-b border-gray-300">      
      <h1 className="text-2xl font-bold truncate">{truncatedTitle}</h1>
      <div className="w-[15%] text-right">
        <span className="text-lg font-semibold">Count: {issue.count}</span>
      </div>
    </div>
  );
};

export default IssueDetailHeader;
